import React from "react";
import TenantInviteHistory from "../../../components/Master/TenantInviteHistory/TenantInviteHistory";

function TenantInviteHistoryPage() {
  return <TenantInviteHistory />;
}

export default TenantInviteHistoryPage;
